import React from 'react'
import { useSelector } from 'react-redux'

import { LookingToJoin, SignInWithProvider, Main } from '../../../components'
import { getOrganization } from './state'
import { JoinDefaultProps } from './types'
import { useAnalytics } from 'hooks/useAnalytics'
import { FormattedMessage } from 'react-intl'

enum SSOProviders {
  Google = 'google',
}

export function FromSSO({
  joinOrigin,
  organizationInviteToken,
  superEnabled,
}: JoinDefaultProps) {
  const track = useAnalytics()
  const organization = useSelector(getOrganization)

  const onClick = (provider: SSOProviders, callback: () => void) => {
    switch (provider) {
      case SSOProviders.Google:
        track('ONBOARDING_JOIN_FROM_SSO_GOOGLE_SIGNUP')
        break
      default:
        throw new Error(`Unknown sign up method ${provider}`)
    }
    setTimeout(() => {
      callback()
    }, 300) // Delay redirection by 300ms - recommended by Segment
  }

  return (
    <Main.Container footer={<LookingToJoin superEnabled={superEnabled} />}>
      <Main.Title>
        <FormattedMessage
          id="boarding.organization.join.sso.title"
          defaultMessage="Join"
          values={{}}
        />
        {organization.name}
      </Main.Title>
      <div className="flexbox-column flexbox-inline">
        <SignInWithProvider
          provider={organization.authMethod}
          rejoin={organization.domain}
          joinOrigin={joinOrigin}
          restrictToDomains={organization.authDomains || ''}
          authProvider={organization.authProvider}
          className="margin-vertical-8"
          onClick={(callback) => onClick(SSOProviders.Google, callback)}
          organizationInviteToken={organizationInviteToken}
          organizationId={organization.id}
          superEnabled={superEnabled}
        />
      </div>
    </Main.Container>
  )
}
